<template>
    <div>

        <Header :flat="flat"/>
        <loading/>
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>

        <!-- <v-main class="pt-0"> -->
        <!-- <v-main class="pt-0" style="background-color: #424242;"> -->
        <v-main class="pt-0" style="background-color: #fff;">

            <router-view/>  

        </v-main>


        <v-scale-transition>
            <v-btn
            fab
            v-show="fab"
            v-scroll="onScroll"
            dark
            fixed
            bottom
            right 
            class="color_secondary"
            @click="toTop">
                <v-icon>fas fa-arrow-up</v-icon>
            </v-btn>
        </v-scale-transition>

        <Footer />
        

    </div>
</template>



<script>
    // client\src\layouts\Home.vue    SE CARGA POR DEFAULT TODO EL HOMEgancho madera

    import Header from './header';
    import Footer from './footer';


    //   name: 'Login',
    export default {
       name: 'App',

         components: {
            Header,
            Footer

        },


        data: () => ({
             //defaultLayout  : 'login_layout'
            fab: null,
            color: "#39FA65E",
            flat: null

        }),

         created() {
            const top = window.pageYOffset || 0;

            if (top <= 60) {
                this.flat = true;
            }
        },

         watch: {
            fab(value) {
                if (value) {
                    this.flat = false;
                }

                else {

                    this.flat = true;
                }
            },
        },



        computed: {
            layout (){
                // return (this.$route.meta.layout || defaultLayout)
                return (this.$route.meta.layout || this.defaultLayout)
            }
        },


        methods: {

            onScroll(e) {
                if (typeof window === "undefined") return;
                const top = window.pageYOffset || e.target.scrollTop || 0;
                this.fab = top > 60;
            },

            toTop() {
                this.$vuetify.goTo(0);
            },





          eventoClick:function(dato){
            console.log(dato);
            },



            eventoTeclado:function(event){
                console.log(event.key);
            },

        }


    }

</script>
